import {Component, computed, inject, input, InputSignal} from '@angular/core';

import {LabeledContentComponent} from '../../../../shared/ui/labeled-content/labeled-content.component';
import {translate} from '@jsverse/transloco';
import {FALLBACK_STRING} from '../../../../shared/constants';
import {InquiryOrder} from '../../data-access/interface/inquiry.interface';
import {AddressService} from '../../../../shared/services/address.service';
import {AddressComponent} from '../../../../shared/ui/address/address.component';

@Component({
  selector: 'cov-inquiry-order-info',
  imports: [LabeledContentComponent, AddressComponent],
  templateUrl: './inquiry-order-info.component.html',
  styleUrl: './inquiry-order-info.component.scss',
})
export class InquiryOrderInfoComponent {
  public order: InputSignal<InquiryOrder | null> = input<InquiryOrder | null>(null);
  protected readonly translate = translate;
  protected readonly FALLBACK_STRING = FALLBACK_STRING;

  public addressService = inject(AddressService);
}
